import React from "react";

export function Card({ children, className = "", ...props }) {
  return (
    <div
      className={`rounded-2xl border shadow-md p-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

